// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'

import { IInputProps } from './Dropzone'
import { useTheme } from '@material-ui/core'
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import AddAPhotoIcon from '@material-ui/icons/AddBox';

const Input = (props: IInputProps) => {
  const theme = useTheme();
  const {
    className,
    labelClassName,
    labelWithFilesClassName,
    style,
    labelStyle,
    labelWithFilesStyle,
    getFilesFromEvent,
    accept,
    multiple,
    disabled,
    content,
    withFilesContent,
    onFiles,
    files,
  } = props
  var IsEmptyFiles = files.length > 0
  var tempstyle = IsEmptyFiles ? labelWithFilesStyle : labelStyle
  var tempColor = theme.palette.type === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main
  return (


    <label
      className={files.length > 0 ? labelWithFilesClassName : labelClassName}
      style={{ ...tempstyle, color: tempColor, margin: 5 }}
    >
      {IsEmptyFiles ? withFilesContent : content}
      <input
        className={className}
        style={style}
        type="file"
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={async e => {
          const target = e.target
          const chosenFiles = await getFilesFromEvent(e)
          onFiles(chosenFiles)
          target.value = null
        }}
      />

      {IsEmptyFiles ? <AddAPhotoIcon style={{ marginLeft: 5 }} /> : <CloudUploadIcon style={{ marginLeft: 5 }} />}


    </label>
  )
}

Input.propTypes = {
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  labelWithFilesClassName: PropTypes.string,
  style: PropTypes.object,
  labelStyle: PropTypes.object,
  labelWithFilesStyle: PropTypes.object,
  getFilesFromEvent: PropTypes.func.isRequired,
  accept: PropTypes.string.isRequired,
  multiple: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  content: PropTypes.node,
  withFilesContent: PropTypes.node,
  onFiles: PropTypes.func.isRequired,
  files: PropTypes.arrayOf(PropTypes.object).isRequired,
  extra: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    reject: PropTypes.bool.isRequired,
    dragged: PropTypes.arrayOf(PropTypes.object).isRequired,
    accept: PropTypes.string.isRequired,
    multiple: PropTypes.bool.isRequired,
    minSizeBytes: PropTypes.number.isRequired,
    maxSizeBytes: PropTypes.number.isRequired,
    maxFiles: PropTypes.number.isRequired,
  }).isRequired,
}

export default Input
